import { combineReducers } from 'redux';
import auth from './authReducer';
import shopify from './shopifyReducer';
import knowledgeBase from './knowledgeBaseReducer';
import email from './emailReducer';
import widget from './widgetReducer';
import conversations from './conversationsReducer';
import voice from './voiceReducer';
import billing from './billingReducer';
import payment from './paymentReducer';
import language from './languageReducer';
import redo from './redoReducer';
import ups from './upsReducer';
import ui from './uiReducer';
import callAgent from './callAgentReducer';
import klaviyo from './klaviyoReducer';
import yotpo from './yotpoReducer';

const appReducer = combineReducers({
  auth,
  shopify,
  knowledgeBase,
  email,
  widget,
  conversations,
  voice,
  billing,
  payment,
  language,
  redo,
  ups,
  ui,
  callAgent,
  klaviyo,
  yotpo,
});

// Reset the whole store on AUTH_LOGOUT to clear stale data and headers
const rootReducer = (state, action) => {
  if (action.type === 'AUTH_LOGOUT') {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
